import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig, MatDialogModule, MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { User } from '../../../../shared/models/user';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AccountService } from '../../../../core/services/account.service';
import { AlertType } from '../../../../shared/models/alertType';
import { showAlertDialog } from '../../../../shared/helpers/showAlertDialog';
import { UsersService } from '../../../../core/services/users.service';

@Component({
    selector: 'app-alterar-senha-dialog',
    imports: [MatIconModule, MatDialogModule, CommonModule, ReactiveFormsModule],
    templateUrl: './alterar-senha-dialog.component.html',
    styleUrl: './alterar-senha-dialog.component.scss'
})
export class AlterarSenhatDialogComponent {
  alterarSenhaForm: FormGroup;
  passwordVisible: boolean = false;
  newpasswordVisible: boolean = false;
  confirmationPasswordVisible: boolean = false;
  novaSenhaFocused: boolean = false;
  confirmeSenhaFocused: boolean = false;
  senhaAtualFocused: boolean = false;
  user: User | null = null;

  constructor(
    public dialogRef: MatDialogRef<AlterarSenhatDialogComponent>,
    private fb: FormBuilder,
    private accountService: AccountService,
    private userService: UsersService,
    private dialog: MatDialog,
  ) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    dialogConfig.panelClass = 'custom-dialog-container';
    this.dialogRef.updateSize('480px');

    this.user = userService.currentUser();

    this.alterarSenhaForm = this.fb.group({
      senhaAtual: ['', Validators.required],
      novaSenha: ['', {
        validators: [
          Validators.required,
          Validators.minLength(8),
          Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*]).+$')
        ],
      }],
      confirmeSenha: ['', {
        validators: [Validators.required],
      }]
    }, { validator: this.passwordMatchValidator });
  }

  passwordMatchValidator(form: FormGroup) {
    const novaSenha = form.get('novaSenha');
    const confirmeSenha = form.get('confirmeSenha');
    if (novaSenha?.value !== confirmeSenha?.value) {
      confirmeSenha?.setErrors({ mismatch: true });
      return { mismatch: true };
    } else {
      confirmeSenha?.setErrors(null);
      return null;
    }
  }

  onSubmit() {
    if(this.alterarSenhaForm.valid){
      this.accountService.changePassword(this.alterarSenhaForm.value.senhaAtual, this.alterarSenhaForm.value.novaSenha)
        .subscribe({
          next: () => {
            const dialogRef = showAlertDialog(this.dialog, AlertType.Success, 'Sucesso!', 'A sua senha foi alterada com sucesso!');
            dialogRef.afterClosed().subscribe(() => {
              window.location.reload();
            });
          }
        });
    }
  }

  close(): void {
    this.dialogRef.close();
  }
}
